/**
 * Entitlement checks against the WorkNest token's `apps` claim, whose entries
 * are `"<salesforceAppId>:<accountExternalId>"`. The Home tiles use the same
 * rule server-side, so a route guarded with this matches the tile exactly.
 */

const toList = (value: string | string[] | undefined | null): string[] =>
    (Array.isArray(value) ? value : [value]).filter((x): x is string => !!x);

export const hasAppForSites = (
    apps: string[] | undefined | null,
    appIds: string | string[] | undefined | null,
    siteIds: Array<string | undefined | null> = []
): boolean => {
    const ids = toList(appIds);
    const sites = toList(siteIds as string[]);

    if (ids.length === 0 || sites.length === 0) return false;

    return (apps ?? []).some((app) => {
        const [appId, accountId] = app.split(":");
        return ids.includes(appId) && sites.includes(accountId);
    });
};
